import { getEnv } from 'utils/env';
import { isBoolean } from 'lodash';

const getRegistrationOpen = () => {
    // because env.js will be the Boolean `true` but it's
    // hard to get docker-compose to pass it in like that we get `"true"`
    // so we'll accept either
    const value = getEnv('REACT_APP_REGISTRATION_OPEN', true);
    if (isBoolean(value)) {
        return value;
    } else {
        return value === 'true' ? true : false;
    }
};

export const REGISTRATION_OPEN = getRegistrationOpen();
